import { CrossIcon } from '../../icons/cross-icon';

interface FailedStateProps {
  violations: Violation[];
  setViolations: (violations: Violation[]) => void;
}

interface Violation {
  name: string;
  reason: string;
}

export const FailedState = ({
  violations,
  setViolations,
}: FailedStateProps) => {
  const label =
    violations.length > 1
      ? 'Your prompt hit these guardrails'
      : 'Your prompt hit a guardrail';

  return (
    <div className='flex flex-col relative w-full rounded-lg border border-gray-200 dark:border-gray-700 shadow py-5 px-6 gap-2 bg-white dark:bg-zinc-800'>
      <div
        className='absolute top-2 right-2 cursor-pointer'
        onClick={() => setViolations([])}
      >
        <CrossIcon
          size={24}
          className='stroke-zinc-800 dark:stroke-zinc-200 hover:stroke-zinc-950 dark:hover:stroke-zinc-50 transition'
        />
      </div>
      <p className='font-semibold text-zinc-900 dark:text-zinc-100'>{label}</p>
      <p className='text-zinc-700 dark:text-zinc-300 text-xs mb-4'>
        The following guardrails will prevent a user from creating content with
        a prompt like this
      </p>
      {violations.length > 0 &&
        violations.map((check: Violation, index: number) => (
          <div
            key={`formattedChecks-${index}`}
            className='bg-zinc-100 dark:bg-zinc-700 py-4 px-5 rounded'
          >
            <p className='font-semibold text-zinc-900 dark:text-zinc-100'>
              {check.name}
            </p>
            <p className='text-zinc-700 dark:text-zinc-300'>{check.reason}</p>
          </div>
        ))}
    </div>
  );
};
